/**
 * Interview Coach 에이전트 샘플 데이터
 *
 * 테스트 및 사용자 편의를 위한 샘플 이력서, 채용 공고 데이터
 */

export const INTERVIEW_COACH_SAMPLE_DATA = {
  resumeText: `[경력]
- (주)테크스타트 (2021.03 - 현재): 백엔드 개발자
  - Python, FastAPI 기반 REST API 개발
  - PostgreSQL 데이터베이스 설계 및 최적화
  - AWS Lambda, ECS 기반 서버리스 아키텍처 구축
  - DAU 50만 서비스 운영 경험

- (주)디지털솔루션 (2019.01 - 2021.02): 주니어 개발자
  - Django 기반 웹 서비스 개발
  - RESTful API 설계 및 구현
  - MySQL 쿼리 최적화

[학력]
- 한국대학교 컴퓨터공학과 졸업 (2019.02)

[스킬]
- Language: Python, TypeScript, SQL
- Framework: FastAPI, Django, React
- Database: PostgreSQL, Redis, MongoDB
- Cloud: AWS (EC2, Lambda, ECS, RDS)
- Tools: Docker, Git, Jira`,

  jobDescriptionText: `[포지션]
백엔드 개발자 (Python/FastAPI)

[주요 업무]
- 대규모 트래픽을 처리하는 REST API 설계 및 개발
- 마이크로서비스 아키텍처 설계 및 구현
- 데이터베이스 스키마 설계 및 쿼리 최적화
- CI/CD 파이프라인 구축 및 유지보수

[자격 요건]
- Python 백엔드 개발 경력 3년 이상
- FastAPI 또는 Django 프레임워크 경험
- PostgreSQL 등 RDBMS 활용 경험
- REST API 설계 및 문서화 경험
- Git을 활용한 협업 경험

[우대 사항]
- AWS, GCP 등 클라우드 서비스 운영 경험
- Docker, Kubernetes 등 컨테이너 기술 경험
- 대규모 트래픽 처리 경험
- 오픈소스 기여 경험`,
};

/**
 * YouTube Insight 에이전트 샘플 데이터
 *
 * 테스트용 샘플 유튜브 URL
 */
export const YOUTUBE_INSIGHT_SAMPLE_DATA = {
  urls: [
    'https://youtu.be/l8HZxvT2sN8?si=Nu38Y6XORBf-cEUH',
    'https://youtu.be/_e9sae0L-AA?si=9LmjcMYlWpGotfqI',
  ],
};
